import {OrderedMap, List, Map, fromJS} from 'immutable';
import moment from 'moment';
import {INITIAL_STATE} from './reducer';

export const isValidRegionName = (state, name) => {
  return name === 'Any' || state.get('regions').valueSeq().some(value => {
    return value.get('name') === name;
  });
};

export const updateDate = (state, date, endDate = null) => {
  return state.set('selectedDate', date).set('endDate', endDate);
};

export const changeScanDaysValue = (state, value) => {
  let nextState = state;
  const selectedScanDays = state.get('scanDays');
  nextState = nextState.set('scanDays', value);

  return nextState.set('scanDays', value);
}

export const changeDurationValue = (state, value) => {
  let nextState = state;
  let selectedDate = state.get('selectedDate', moment());
  let duration = 7;

     switch (value) {
      case '8 nights (11-19 December 2021 only)':
         selectedDate = moment('2021-12-11T12:00:00.000Z');
        duration = 8;
        break;

      case '7 nights (Saturday to Saturday 25 December to 1 January 2022 only)':
         selectedDate = moment('2021-12-25T12:00:00.000Z');
        break;

      case '7 nights (Sunday to Sunday 19-26 December 2021 only)':
         selectedDate = moment('2021-12-19T12:00:00.000Z');
        break;

      case '7 nights (Sunday to Sunday 26 December to 2 January 2022 only)':
         selectedDate = moment('2021-12-26T12:00:00.000Z');
        break;

      case '6 nights (2-8 January 2022 only)':
         selectedDate = moment('2022-01-02T12:00:00.000Z');
        duration = 6;
        break;
  }

    const seasonStartDate = moment(state.get('seasonStartDate'), 'DD/MM/YYYY');
    const seasonEndDate = moment(state.get('seasonEndDate'), 'DD/MM/YYYY');

    selectedDate.subtract(7, 'days');
    do {
      selectedDate = selectedDate.add(7, 'days');
    } while (selectedDate.isBefore(seasonStartDate) || selectedDate.isBefore(moment()));
    selectedDate = moment().isBefore(seasonStartDate) ? seasonStartDate : moment().isAfter(seasonEndDate) ? seasonEndDate : selectedDate;

    if (selectedDate.isAfter(seasonEndDate)) {
      selectedDate.subtract(7, 'days');
    }

    nextState = nextState.set('selectedDate', selectedDate);
  

  return nextState.set('duration', value);
};

export const setParentResortAndRegion = (state, accommodationName) => {
  let region = 'Any';
  let resort = 'Any';

  if (accommodationName === '' || accommodationName === 'Any') {
    return state;
  }

  state.get('regions').valueSeq().forEach(regionValue => {
    regionValue.get('resorts').valueSeq().forEach(resortValue => {
      resortValue.get('accommodation').valueSeq().forEach(accommodationValue => {
        if (accommodationValue.get('name') === accommodationName) {
          region = regionValue.get('name');
          resort = resortValue.get('name');
        }
      });
    });
  });
  return state.setIn(['inputFields', 'regions', 'value'], region)
    .setIn(['inputFields', 'resorts', 'value'], resort);
};

export const setParentRegion = (state, resortName) => {
  if (resortName === '' || resortName === 'Any') {
    return state;
  }
  let region = 'Any';
  state.get('regions').valueSeq().forEach(regionValue => {
    regionValue.get('resorts').valueSeq().forEach(resortValue => {
      if (resortValue.get('name') === resortName) {
        region = regionValue.get('name');
      }
    });
  });
  return state.setIn(['inputFields', 'regions', 'value'], region);
};

export const isValidResortName = (state, name) => {
  return name === 'Any' || state.get('regions').valueSeq().some(value => {
    return value.get('name') === name;
  });
};

export const updateDiamondAndAvailproCodes = (state) => {


  const selectedRegion = state.getIn(['inputFields', 'regions', 'value']);
  const selectedResort = state.getIn(['inputFields', 'resorts', 'value']);
  const selectedAccommodation = state.getIn(['inputFields', 'accommodation', 'value']);

  let regionDiamondCode = '';
  let resortDiamondCode = '';
  let accommodationDiamondCode = '';
  let regionAvailproCode = '';
  let resortAvailproCode = '';
  let accommodationAvailproCode = '';
  let regionNodeId = '';
  let resortNodeId = '';
  let accommodationNodeId = '';


  //loop through regions to find the selected one

  state.get('regions').valueSeq().forEach(value => {
    if (value.get('name') === selectedRegion) {
      regionDiamondCode = value.get('diamondCode');
      regionAvailproCode = value.get('availproCode');
      regionNodeId = value.get('nodeId');
    }

    const resorts = value.get('resorts');
    resorts.valueSeq().forEach(value => {
      if (value.get('name') === selectedResort) {
        resortDiamondCode = value.get('diamondCode');
        resortAvailproCode = value.get('availproCode');
        resortNodeId = value.get('nodeId');
      }

      const accommodation = value.get('accommodation');
      accommodation.valueSeq().forEach(value => {
        if (value.get('name') === selectedAccommodation) {
          accommodationDiamondCode = value.get('diamondCode');
          accommodationAvailproCode = value.get('availproCode');
          accommodationNodeId = value.get('nodeId');
        }
      });
    });
  });

  return state.setIn(['inputFields', 'regions', 'availproCode'], regionAvailproCode)
    .setIn(['inputFields', 'regions', 'diamondCode'], regionDiamondCode)
    .setIn(['inputFields', 'regions', 'nodeId'], regionNodeId)
    .setIn(['inputFields', 'resorts', 'diamondCode'], resortDiamondCode)
    .setIn(['inputFields', 'resorts', 'nodeId'], resortNodeId)
    .setIn(['inputFields', 'resorts', 'availproCode'], resortAvailproCode)
    .setIn(['inputFields', 'accommodation', 'availproCode'], accommodationAvailproCode)
    .setIn(['inputFields', 'accommodation', 'nodeId'], accommodationNodeId)
    .setIn(['inputFields', 'accommodation', 'diamondCode'], accommodationDiamondCode);

};

export const showResortErrorMessage = (state, show) => state.set('resortErrorMessageShowing', show);

export const updateTextField = (_state, name, value, inOnChange = false) => {
  let state = _state;
  const currentValue = state.getIn(['inputFields', name, 'value']);

  if (name === 'accommodation') {
    state = setParentResortAndRegion(state, value);
  }

  if (name === 'resorts') {
    state = setParentRegion(state, value);

    if (value !== 'Any' && value !== '') {
      state = state.setIn(['inputFields', 'accommodation', 'value'], 'Any');
    }
  }

  if (name === 'regions') {
    state = setParentRegion(state, value);

    if (value !== 'Any' && value !== '' && !inOnChange) {
      state = state.setIn(['inputFields', 'accommodation', 'value'], 'Any');
      state = state.setIn(['inputFields', 'resorts', 'value'], 'Any');
    }
  }

  if (currentValue !== '') {
    state = state.setIn(['inputFields', name, 'previousValue'], currentValue);
  }

  if (name === 'resorts') {
    state = state.set('resortErrorMessageShowing', false);
  }
  return state.setIn(['inputFields', name, 'value'], value);
};

export const setStateFromJson = (_initialData) => {
  let initialData = _initialData;
  try {
    initialData = JSON.parse(initialData);
  } catch (exception) {
    console.warn('JSON parsing on the booking form failed', exception);
  }
  return fromJS(initialData).merge(INITIAL_STATE);
};

export const blurInput = (state, name, value) => {
  switch (name) {
    case 'region':
      if (!value) {
        return updateTextField(state, name, state.getIn(['regions']).first().get('name'));
      }
      break;
  }
  return state;
};
